// extracted by mini-css-extract-plugin
export default {"SearchFilter":"SearchFilter_SearchFilter__lD2nW"};